module.exports = __webpack_public_path__ + "static/media/landing-analytics-icon.34e36a80.svg";